<template>
  <div
    class="c-checkbox"
  >
    <input
      v-model="checked"
      class="c-checkbox__input"
      :name="nameFor"
      type="checkbox"
      true-value="yes"
      false-value="no"
      :aria-hidden="ariaHiddenCheckbox"
    >
    <label
      class="c-checkbox__label"
      :for="nameFor"
      @click="toggleValue"
    >
      <slot />
    </label>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    ariaHiddenCheckbox: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    nameFor() {
      return `c-checkbox--${this._uid}`
    },
    checked: {
      get() {
        return (this.value) ? 'yes' : 'no'
      },
      set(value) {
        this.$emit('input', value === 'yes')
      }
    },
  },
  methods: {
    toggleValue() {
      this.$emit('input', !this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.c-checkbox {
  &__input {
    position: absolute;
    opacity: 0;
  }
  &__label {
    position: relative;
    cursor: pointer;
    padding: 0;
    font-size: rem(16px);
    font-weight: 300;
    letter-spacing: rem(.5px);
    line-height: rem(21px);
    user-select: none;
    @include themify($themes) {
      color: themed('foreground');
    }
  }
  &__label::before {
    content: "";
    margin-right: rem(10px);
    display: inline-block;
    vertical-align: middle;
    width: rem(25px);
    height: rem(25px);
    border-radius: rem(3px);
    @include themify($themes) {
      border: 1px solid themed('foreground', 'white');
    }
    speak: none;
  }
  &__input:checked + &__label {
    &::before {
      @include themify($themes) {
        background: themed('foreground', 'white');
      }
      @media reader, speech, aural {
        display: none;
        visibility: hidden;
      }
    }
    &::after {
      content: "\2713";
      position: absolute;
      width: rem(25px);
      height: rem(25px);
      left: 0;
      top: -2px;
      text-align: center;
      line-height: rem(25px);
      display: block;
      @include themify($themes) {
        color: themed('foreground', 'base');
      }
    }
  }
  &--progress &__label {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  &--progress &__label::before {
    margin-right: 0;
    margin-bottom: rem(6px);
    @include themify($themes) {
      background: themed('primary');
    }
    border-radius: 50%;
    width: rem(16px);
    height: rem(16px);
  }
  &--progress &__input:checked + &__label {
    &::before {
      @include themify($themes) {
        background: themed('primary');
      }
    }
    &::after {
      font-size: rem(11px);
      width: rem(16px);
      margin: 0 auto;
      left: 0;
      right: 0;
      top: rem(-4px);
      speak: none;
      @include themify($themes) {
        color: themed('foreground', 'white-text');
      }
    }
  }
}
</style>
